import {ChangeEvent, ReactElement, useEffect, useState} from 'react'
import {apiRequest, getErrorMessage, PATH_TEXT_BLOCK_UPDATE, PATH_TEXT_BLOCK_VIEW} from '../../common/backend'
import M from 'materialize-css'
import TextEditor from '../../common/component/TextEditor'
import FixedSaveButton from '../../common/component/FixedSaveButton'
import {useTranslation} from 'react-i18next'
import useML from "../../hook/UseML";
import TranslatableTextInput from "../../common/component/TranslatableTextInput";
import LocalizedString from "../../common/component/LocalizedString";
import PageLoader from "../../common/component/PageLoader";

interface InfoPageProps {
    id: number | null
}

const InfoPage = ({id}: InfoPageProps): ReactElement => {
    const [loading, setLoading] = useState<boolean>(false)
    const [state, setState] = useState<TextBlock | null>(null)
    const {t, i18n} = useTranslation()

    const {language, availableLanguages, setLanguage} = useML(i18n.language)

    useEffect((): void => {
        if (id === null || isNaN(id)) {
            setState(null)
            return
        }
        setLoading(true)
        apiRequest(PATH_TEXT_BLOCK_VIEW + id, (res: { data: TextBlock }): void => {
            setState(res.data)
            // @ts-ignore
        }, err => {
            M.toast({html: getErrorMessage(err), classes: 'rounded red large'})
        }, undefined, 'GET')!!
            .finally((): void => {
                setLoading(false)
            })
    }, [id])

    const save = (): void => {
        setLoading(true)
        apiRequest(PATH_TEXT_BLOCK_UPDATE + state!!.id, (): void => {
            M.toast({html: t('info.saved'), classes: 'rounded green large'})
            // @ts-ignore
        }, (err): void => {
            console.log(err)
            M.toast({html: getErrorMessage(err), classes: 'rounded red large'})
        }, state!!, 'PUT')!!
            .finally((): void => {
                setLoading(false)
            })
    }

    if (availableLanguages === null || state === null || language === null) {
        return <></>
    }

    return <>
        {loading && <PageLoader/>}
        <h4>
            <LocalizedString str={state?.name}/>
        </h4>
        <div className="row s12">
            <select className='browser-default' value={language}
                    onChange={(e: ChangeEvent<HTMLSelectElement>): void => {
                        setLanguage(e.target.value)
                    }}>
                {availableLanguages.map((it: string): ReactElement => {
                    return <option key={it} value={it}>{it}</option>
                })}
            </select>
            <TranslatableTextInput classes='' initialValue={state.name} update={(val: string): void => {
                state.name = val
            }} language={language}/>
            {/* @ts-ignore */}
            <TextEditor defaultText={state.text} handleChange={(_: any, el: string): void => {
                state.text = el
            }} language={language}/>
        </div>
        <FixedSaveButton action={save}/>
    </>
}

export default InfoPage;
